import { render, staticRenderFns } from "./AdCarousel.vue?vue&type=template&id=45d30f3a&scoped=true"
import script from "./AdCarousel.vue?vue&type=script&lang=js"
export * from "./AdCarousel.vue?vue&type=script&lang=js"
import style0 from "./AdCarousel.vue?vue&type=style&index=0&id=45d30f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d30f3a",
  null
  
)

export default component.exports